










import { Component, Prop, Vue, Watch } from 'saiten-base';
import { ConstsState, Modal, SaitenApi } from "saiten-base";

// CombineUploader, http, DmModal, dm_service
@Component({components: {Modal}, mixins:[]})
export default class RejectDialog extends Vue {
  get dialog() {return this.$refs.my_dialog as any}
  sheet_activity: any | null = null;
  selected_message: number | null = null ;
  messages = {
    '画像がぼやけている': 1,
    '画像が回転している': 2,
    '異なる答案が含まれている': 3,
    'ページの順番が異なっている': 4
  }
  mounted(){
  }
  show(sheet_activity: any){
    this.sheet_activity = sheet_activity;
    const reject_kind = Object.keys(this.messages).indexOf(this.sheet_activity.reject_kind)
    if(reject_kind >= 0){
      this.selected_message = reject_kind + 1 ;
    } else {
      this.selected_message = null ;
    }
    this.dialog.show();
  }
  async exec(){
    try{
      await SaitenApi.reject_sheet_activity(this.sheet_activity.id, {message:this.selected_message})
      alert("エラー登録しました")
      this.dialog.hide();
    }catch(err){
      alert('エラー登録に失敗しました')
    }
  }
}
